<template>
    <section class="ifr__section ifr__section--map">
        <div class="-ui-container">
            <header class="ifr__header ifr__header--intro">
                <!--<h4>{{ $t('map.intro.h4') }}</h4>-->
                <h3>{{ $t('map.intro.h3') }}</h3>
                <div class="ifr__header-content" v-html="$t('map.intro.content')"></div>
            </header>
        </div>
        <div class="-ui-container -ui-container-lg">
            <div class="-ui-grid">
                <div class="-ui-col-50">
                     <header class="ifr__header ifr__header--about">
                        <h4>{{ $t('map.about.h4') }}</h4>
                        <h3>{{ $t('map.about.h3') }}</h3>
                        <div class="ifr__header-content" v-html="$t('map.about.content')"></div>
                    </header>
                    <div class="ifr__legend">
                        <ul class="ifr__select">
                            <li>
                                <button :class="[{'is--active': currentDisplay == 'deaths'}]" @click="currentDisplay = 'deaths'; redrawMap();">
                                    <span>{{ $t('map.about.deaths') }}</span>
                                    <span>{{ $t('map.about.deaths') }}</span>
                                </button>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentDisplay == 'cases'}]" @click="currentDisplay = 'cases'; redrawMap();">
                                    <span>{{ $t('map.about.cases') }}</span>
                                    <span>{{ $t('map.about.cases') }}</span>
                                </button>
                            </li>
                        </ul>
                        <p class="ifr__footnote">{{ $t('map.about.footnote') }}</p>
                        <div :class="['ifr__range-group ifr__range--deaths', {'is--active':currentDisplay == 'deaths'}]">
                            <div class="ifr__range"></div>
                            <ul class="ifr__range-data">
                                <li>0</li>
                                <li>20</li>
                                <li>40</li>
                                <li>60</li>
                                <li>80</li>
                            </ul>
                        </div>
                        <div :class="['ifr__range-group ifr__range--cases', {'is--active':currentDisplay == 'cases'}]">
                            <div class="ifr__range"></div>
                            <ul class="ifr__range-data">
                                <li>0</li>
                                <li>60</li>
                                <li>120</li>
                                <li>180</li>
                            </ul>
                        </div>
                        
                    </div>
                    <div class="ifr__timeline">
                        <div class="ifr__title">{{ $t('map.about.timeline') }}</div>
                        <ul>
                            <li>
                                <button :class="[{'is--active': currentYear == 1990}]" @click="currentYear = 1990; redrawMap();"></button>
                                <span>1990</span>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentYear == 1995}]" @click="currentYear = 1995; redrawMap();"></button>
                                <span>1995</span>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentYear == 2000}]" @click="currentYear = 2000; redrawMap();"></button>
                                <span>2000</span>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentYear == 2005}]" @click="currentYear = 2005; redrawMap();"></button>
                                <span>2005</span>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentYear == 2010}]" @click="currentYear = 2010; redrawMap();"></button>
                                <span>2010</span>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentYear == 2015}]" @click="currentYear = 2015; redrawMap();"></button>
                                <span>2015</span>
                            </li>
                            <li>
                                <button :class="[{'is--active': currentYear == 2017}]" @click="currentYear = 2017; redrawMap();"></button>
                                <span>2017</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="-ui-col-50 ifr__map">
                    <div id="ifr__map"></div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import leaflet from 'leaflet'
import americaCountries from '../assets/maps/map.js'
import chroma from 'chroma-js'
export default {
    name: 'map-data',
    data() {
        return {
            currentDisplay: 'deaths',
            currentYear: 1990,
            map: null
        }
    },
    methods: {
        redrawMap() {
            this.map.remove()
            this.renderMap()
        },
        renderMap() {
            var THIS = this
            var zoomSnap 
            var zoom 
            if (window.innerWidth > 1024) {
                zoom = 2
                zoomSnap = 1.25
            }
            if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
                zoom = 2
            }
            if (window.innerWidth < 768) {
                zoom = 1
                zoomSnap = 1.75
            }
            THIS.map = L.map('ifr__map', {
                center: [39.74739, -105],
                zoom: zoom,
                zoomSnap: zoomSnap,
                zoomControl:false,
                scrollWheelZoom: false,
                dragging: false,
                doubleClickZoom: false,
                boxZoom: false
            })
            function getColor(d) {
                

                /*
                return d > 1000 ? '#800026' :
                    d > 60  ? '#BD0026' :
                    d > 50  ? '#E31A1C' :
                    d > 40  ? '#FC4E2A' :
                    d > 30   ? '#FD8D3C' :
                    d > 20   ? '#FEB24C' :
                    d > 10   ? '#FED976' :
                                '#FFEDA0';
                                */
            }
            function style(feature) {
                var d
                if (THIS.currentYear == 1990 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d1990)
                }
                if (THIS.currentYear == 1995 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d1995)
                }
                if (THIS.currentYear == 2000 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d2000)
                }
                if (THIS.currentYear == 2005 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d2005)
                }
                if (THIS.currentYear == 2010 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d2010)
                }
                if (THIS.currentYear == 2015 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d2015)
                }
                if (THIS.currentYear == 2017 && THIS.currentDisplay == 'deaths') {
                    d = parseInt(feature.properties.d2017)
                }
                if (THIS.currentYear == 1990 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c1990)
                }
                if (THIS.currentYear == 1995 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c1995)
                }
                if (THIS.currentYear == 2000 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c2000)
                }
                if (THIS.currentYear == 2005 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c2005)
                }
                if (THIS.currentYear == 2010 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c2010)
                }
                if (THIS.currentYear == 2015 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c2015)
                }
                if (THIS.currentYear == 2017 && THIS.currentDisplay == 'cases') {
                    d = parseInt(feature.properties.c2017)
                }
                var colorScale = chroma
                .scale(['#fff466', '#c54149'])
                .domain([0,100]);
                var color = colorScale(parseInt(String(d).substring(0, 3))).hex();
                return {
                    weight: 1,
                    opacity: 1,
                    color: 'white',
                    dashArray: '0',
                    fillOpacity: 1,
                    fillColor: color
                };
            }
            function resetHighlight(e) {
                geojson.resetStyle(e.target);
                /*
                var popup = L.popup({closeOnClick: false, autoPan: false})
                .setLatLng(e.latlng) //(assuming e.latlng returns the coordinates of the event)
                .setContent()
                .openOn(map);
                */
            }
            function zoomToFeature(e) {
		       THIS.map.fitBounds(e.target.getBounds());
	        }
            function highlightFeature(e) {
                var d = null
                if (THIS.currentYear == 1990 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d1990
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 1995 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d1995
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2000 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d2000
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2005 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d2005
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2010 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d2010
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2015 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d2015
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2017 && THIS.currentDisplay == 'deaths') {
                    d = e.target.feature.properties.d2017
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 1990 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c1990
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 1995 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c1995
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2000 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c2000
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2005 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c2005
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2010 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c2010
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2015 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c2015
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                if (THIS.currentYear == 2017 && THIS.currentDisplay == 'cases') {
                    d = e.target.feature.properties.c2017
                    d = d.replace(/,/g, '.')
                    d = parseFloat(d).toFixed(2)
                }
                // Show tooltip
                var layer = e.target;
                var popup = L.popup({closeOnClick: false, autoPan: false})
                .setLatLng(e.latlng) //(assuming e.latlng returns the coordinates of the event)
                .setContent(e.target.feature.properties.name + ': ' + d)
                .openOn(THIS.map);

                // Layer opacity
                layer.setStyle({
                    fillOpacity: 0.8,
                });

                if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                    layer.bringToFront();
                }
            }
            function onEachFeature(feature, layer) {
		        layer.on({
			        mouseover: highlightFeature,
			        mouseout: resetHighlight
			        //click: zoomToFeature
		        });
	        }
            var geojson;
            geojson = L.geoJson(americaCountries, {
		        style: style,
		        onEachFeature: onEachFeature
	        }).addTo(THIS.map);
           
            
            
        }
    },
    mounted() {
        this.renderMap()
    }
}
</script>
<style>
#ifr__map {
    height: 400px;
}
</style>

